import { RootState } from '..';

export const selectJWT = (state: RootState) => state.access.jwt;
